// AI Care 관련 API 함수
import axios, { AxiosPromise, AxiosRequestConfig } from 'axios';
import { IGetAIAnalysisGuide, IGetAlexLearningRecords, IGetCurrentSemesterExams, IGetExamDetail, IGetExamHistory, IGetExamTrend, IGetExamTrendLT, IGetLatestCounsel, IGetLearningDiagnosis, IGetReadiLearningRecords, IGetSkillAnalysis, IGetStudentInfoWithAbsence, IGetWrongAnswerAnalysis } from '../models/aiCare.model';
import { getAiCareUrl } from '../lib/util';

const uri = getAiCareUrl();
const devAddParam = process.env.REACT_APP_IS_DEV === 'Y' ? '?base_date=20251115' : '';

export const getStudentInfoWithAbsense = (memberCode: string, jwtToken?: string): AxiosPromise<IGetStudentInfoWithAbsence> => {
    const config: AxiosRequestConfig = {};
    if (jwtToken) {
        config.headers = { 'Authorization': `Bearer ${jwtToken}` };
    }
    return axios.get(`${uri}/api/v2/student/${memberCode}/info-with-absence${devAddParam}`, config);
}

export const getReadiLearningData = (memberCode: string, jwtToken?: string): AxiosPromise<IGetReadiLearningRecords> => {
    const config: AxiosRequestConfig = {};
    if (jwtToken) {
        config.headers = { 'Authorization': `Bearer ${jwtToken}` };
    }
    return axios.get(`${uri}/api/v2/readi/${memberCode}/learning-units${devAddParam}`, config);
}

export const getAlexLearningData = (memberCode: string, jwtToken?: string): AxiosPromise<IGetAlexLearningRecords> => {
    const config: AxiosRequestConfig = {};
    if (jwtToken) {
        config.headers = { 'Authorization': `Bearer ${jwtToken}` };
    }
    return axios.get(`${uri}/api/v2/alex/${memberCode}/learning${devAddParam}`, config);
}

export const getLatestCounselData = (memberCode: string, jwtToken?: string): AxiosPromise<IGetLatestCounsel> => {
    const config: AxiosRequestConfig = {};
    if (jwtToken) {
        config.headers = { 'Authorization': `Bearer ${jwtToken}` };
    }
    return axios.get(`${uri}/api/v2/student/${memberCode}/counsel-latest`, config);
}

export const getExamHistoryData = (memberCode: string, jwtToken?: string): AxiosPromise<IGetExamHistory> => {
    const config: AxiosRequestConfig = {};
    if (jwtToken) {
        config.headers = { 'Authorization': `Bearer ${jwtToken}` };
    }
    return axios.get(`${uri}/api/v2/exam/${memberCode}/list`, config);
}

export const getExamCurrentSemesterData = (memberCode: string, jwtToken?: string): AxiosPromise<IGetCurrentSemesterExams> => {
    const config: AxiosRequestConfig = {};
    if (jwtToken) {
        config.headers = { 'Authorization': `Bearer ${jwtToken}` };
    }
    return axios.get(`${uri}/api/v2/exam/${memberCode}/current-semester${devAddParam}`, config);
}

export const getExamDetailData = (exam_test_code: string, jwtToken?: string): AxiosPromise<IGetExamDetail> => {
    const config: AxiosRequestConfig = {};
    if (jwtToken) {
        config.headers = { 'Authorization': `Bearer ${jwtToken}` };
    }
    return axios.get(`${uri}/api/v2/exam/detail/${exam_test_code}`, config);
}

export const getExamTrendMTData = (exam_test_code: string, memberCode: string, jwtToken?: string): AxiosPromise<IGetExamTrend> => {
    const config: AxiosRequestConfig = {};
    if (jwtToken) {
        config.headers = { 'Authorization': `Bearer ${jwtToken}` };
    }
    return axios.get(`${uri}/api/v2/exam/trend/${exam_test_code}/${memberCode}`, config);
}

export const getExamTrendLTData = (exam_test_code: string, memberCode: string, jwtToken?: string): AxiosPromise<IGetExamTrendLT> => {
    const config: AxiosRequestConfig = {};
    if (jwtToken) {
        config.headers = { 'Authorization': `Bearer ${jwtToken}` };
    }
    return axios.get(`${uri}/api/v2/exam/lt-trend/${exam_test_code}/${memberCode}`, config);
}

//스킬 분석
export const getSkillAnalysisData = (exam_test_code: string, jwtToken?: string): AxiosPromise<IGetSkillAnalysis> => {
    const config: AxiosRequestConfig = {};
    if (jwtToken) {
        config.headers = { 'Authorization': `Bearer ${jwtToken}` };
    }
    return axios.get(`${uri}/api/v2/exam/skill-analysis/${exam_test_code}`, config);
}

//학습 종합 진단 & 개선 전략
export const getLearningDiagnosisData = (exam_test_code: string, learning_period_start: string, learning_period_end: string, jwtToken?: string): AxiosPromise<IGetLearningDiagnosis> => {
    const config: AxiosRequestConfig = {};
    if (jwtToken) {
        config.headers = { 'Authorization': `Bearer ${jwtToken}` };
    }
    return axios.get(`${uri}/api/v2/exam/performance/${exam_test_code}?learning_period_start=${learning_period_start}&learning_period_end=${learning_period_end}`, config);
}

//오답 문항 상세 분석
export const getWrongAnswerAnalysisData = (exam_test_code: string, skill_code: number, jwtToken?: string): AxiosPromise<IGetWrongAnswerAnalysis> => {
    const config: AxiosRequestConfig = {};
    if (jwtToken) {
        config.headers = { 'Authorization': `Bearer ${jwtToken}` };
    }
    return axios.get(`${uri}/api/v2/exam/incorrect-quiz-by-indicator?exam_test_code=${exam_test_code}&skill_code=${skill_code}`, config);
}

//AI 총평 및 데이터 해석 상담 가이드
export const getAIAnalysisGuideData = (exam_test_code: string, jwtToken?: string): AxiosPromise<IGetAIAnalysisGuide> => {
    const config: AxiosRequestConfig = {};
    if (jwtToken) {
        config.headers = { 'Authorization': `Bearer ${jwtToken}` };
    }
    return axios.get(`${uri}/api/v2/exam/agent-analysis/${exam_test_code}`, config);
}